<div (click)="click()" class="checkbox" [ngClass]="{'clicked': value, 'mb-1': withMarginBottom}">
    <span>{{label}}</span>
</div>